export const categories = [
  {
    id: 'platform-intro',
    name: '平台介绍',
    icon: 'ri-information-line',
    description: '全方位了解喑网91平台的基本信息、发展历程与核心定位',
    articles: [
      { id: 'intro-1', title: '喑网91平台全面介绍', excerpt: '喑网91是一个综合性的网络服务平台，本文详细介绍平台的核心定位、发展历程和未来规划。', date: '2026-08-10', readTime: '8分钟', slug: 'platform-overview' },
      { id: 'intro-2', title: '喑网91的发展历程与里程碑', excerpt: '回顾喑网91从创立至今的重要发展节点，见证平台的成长与蜕变。', date: '2026-08-05', readTime: '6分钟', slug: 'development-history' },
      { id: 'intro-3', title: '喑网91平台架构解析', excerpt: '深入了解喑网91的技术架构设计，包括系统组成、功能模块布局与服务交互机制。', date: '2026-07-28', readTime: '10分钟', slug: 'platform-architecture' },
    ],
  },
  {
    id: 'feature-guide',
    name: '功能指南',
    icon: 'ri-guide-line',
    description: '喑网91各项核心功能的详细使用教程与操作步骤说明',
    articles: [
      { id: 'feat-1', title: '喑网91核心功能使用教程', excerpt: '手把手教您掌握喑网91的核心功能，从注册到高级操作的完整指南。', date: '2026-08-12', readTime: '12分钟', slug: 'core-features-tutorial' },
      { id: 'feat-2', title: '喑网91智能匹配功能详解', excerpt: '了解喑网91智能匹配功能的工作原理、使用方法与最佳实践建议。', date: '2026-08-08', readTime: '7分钟', slug: 'smart-matching' },
      { id: 'feat-3', title: '喑网91数据分析面板使用指南', excerpt: '全面解析喑网91数据面板的各项指标含义与数据解读方法。', date: '2026-08-01', readTime: '9分钟', slug: 'data-analytics-guide' },
    ],
  },
  {
    id: 'version-update',
    name: '版本更新',
    icon: 'ri-refresh-line',
    description: '喑网91最新版本发布信息、功能更新日志与升级说明',
    articles: [
      { id: 'ver-1', title: '喑网91最新版本发布公告', excerpt: '喑网91最新版本正式上线，带来多项重大功能升级与性能优化，全面提升用户体验。', date: '2026-08-11', readTime: '5分钟', slug: 'latest-version-release' },
      { id: 'ver-2', title: '喑网91版本更新日志汇总', excerpt: '按时间线汇总喑网91历次重要版本更新的详细内容与功能变更记录。', date: '2026-08-06', readTime: '8分钟', slug: 'version-changelog' },
      { id: 'ver-3', title: '喑网91新版本升级注意事项', excerpt: '升级到喑网91最新版本前需要了解的重要事项与兼容性说明。', date: '2026-07-30', readTime: '6分钟', slug: 'upgrade-notes' },
    ],
  },
  {
    id: 'security',
    name: '安全保障',
    icon: 'ri-shield-check-line',
    description: '喑网91安全防护机制、隐私保护政策与用户数据管理说明',
    articles: [
      { id: 'sec-1', title: '喑网91安全防护体系详解', excerpt: '全面了解喑网91多层安全防护架构，包括数据加密、访问控制与风险监控机制。', date: '2026-08-09', readTime: '10分钟', slug: 'security-system' },
      { id: 'sec-2', title: '喑网91用户隐私保护承诺', excerpt: '喑网91对用户隐私保护的郑重承诺，详细说明数据收集、使用与保护措施。', date: '2026-08-03', readTime: '7分钟', slug: 'privacy-protection' },
      { id: 'sec-3', title: '喑网91账号安全最佳实践', excerpt: '保护您的喑网91账号安全的实用建议，包括密码管理、双因素认证等内容。', date: '2026-07-25', readTime: '6分钟', slug: 'account-security' },
    ],
  },
  {
    id: 'user-stories',
    name: '用户故事',
    icon: 'ri-user-heart-line',
    description: '喑网91用户的真实使用案例、经验分享与成功故事',
    articles: [
      { id: 'story-1', title: '如何在喑网91上提升工作效率', excerpt: '一位资深用户分享利用喑网91提升日常工作效率的实用经验与技巧。', date: '2026-08-07', readTime: '8分钟', slug: 'efficiency-tips' },
      { id: 'story-2', title: '企业用户眼中的喑网91', excerpt: '多位企业用户分享喑网91在企业场景中的实际应用价值与使用心得。', date: '2026-07-29', readTime: '9分钟', slug: 'enterprise-perspective' },
      { id: 'story-3', title: '喑网91新手上路日记', excerpt: '一位新用户记录从零开始学习使用喑网91的真实体验与成长历程。', date: '2026-07-22', readTime: '7分钟', slug: 'beginner-diary' },
    ],
  },
];

export const allArticles = categories.flatMap((cat) =>
  cat.articles.map((article) => ({
    ...article,
    categoryId: cat.id,
    categoryName: cat.name,
    categoryIcon: cat.icon,
  }))
);

export const articleDetails: Record<string, {
  title: string;
  date: string;
  category: string;
  content: string[];
  relatedArticles: { title: string; slug: string }[];
}> = {
  'platform-overview': {
    title: '喑网91平台全面介绍',
    date: '2026-08-10',
    category: '平台介绍',
    content: [
      '喑网91是一个综合性的网络服务平台，致力于为广大用户提供高效、安全、便捷的在线服务体验。自平台上线以来，喑网91始终坚持以用户需求为导向，不断优化产品功能与服务质量。',
      '喑网91平台集成了智能匹配、数据分析、个性化定制等多项核心功能模块，覆盖个人用户与企业客户的多元化需求。通过先进的技术架构与人性化的交互设计，喑网91为用户打造了一个全方位的一站式网络服务平台。',
      '在安全方面，喑网91采用多层安全防护机制，包括数据加密传输、访问权限控制、实时风险监控等技术手段，全面保障用户数据安全与隐私权益。平台严格遵守国家相关法律法规，建立了完善的数据保护与合规体系。',
      '喑网91的未来发展将持续聚焦技术创新与服务升级，通过引入人工智能、大数据分析等前沿技术，不断提升平台的智能化水平与服务能力，为用户创造更大的价值。',
      '无论您是初次接触喑网91的新用户，还是已经使用多年的老朋友，喑网91都将一如既往地为您提供最优质的服务体验。欢迎您深入探索喑网91的各项功能，感受智能网络服务带来的便捷与高效。',
    ],
    relatedArticles: [
      { title: '喑网91的发展历程与里程碑', slug: 'development-history' },
      { title: '喑网91核心功能使用教程', slug: 'core-features-tutorial' },
      { title: '喑网91安全防护体系详解', slug: 'security-system' },
    ],
  },
  'development-history': {
    title: '喑网91的发展历程与里程碑',
    date: '2026-08-05',
    category: '平台介绍',
    content: [
      '喑网91自创立以来，经历了从概念验证到成熟平台的完整发展历程。最初，创始团队基于对网络服务市场的深入洞察，确立了喑网91的核心产品理念——打造一个安全、高效、智能的综合网络服务平台。',
      '在平台发展的第一阶段，喑网91完成了核心架构的搭建与基础功能的开发。团队专注于打造稳定可靠的技术底座，为后续的功能扩展奠定了坚实的基础。',
      '随着用户规模的快速增长，喑网91进入了快速发展期。平台陆续推出了智能匹配、数据分析、个性化定制等创新功能，显著提升了用户体验与平台竞争力。同时也建立了完善的客户服务体系，确保用户问题能够得到及时有效的解决。',
      '如今，喑网91已经发展成为服务数百万用户的成熟平台，覆盖全国各大城市，赢得了广泛的用户信赖与行业认可。未来，喑网91将继续秉持创新驱动的理念，为用户提供更加优质的服务。',
    ],
    relatedArticles: [
      { title: '喑网91平台全面介绍', slug: 'platform-overview' },
      { title: '喑网91平台架构解析', slug: 'platform-architecture' },
      { title: '喑网91最新版本发布公告', slug: 'latest-version-release' },
    ],
  },
  'platform-architecture': {
    title: '喑网91平台架构解析',
    date: '2026-07-28',
    category: '平台介绍',
    content: [
      '喑网91的平台架构采用业界领先的分布式系统设计理念，确保平台具备高可用性、高扩展性和高安全性。整体架构分为前端交互层、业务逻辑层、数据处理层和基础设施层四个核心组成部分。',
      '前端交互层负责用户界面呈现与交互响应，采用现代化的响应式设计，确保在不同设备上都能提供一致流畅的使用体验。喑网91的界面设计遵循简洁直观的原则，降低用户的学习成本。',
      '业务逻辑层是喑网91的核心大脑，承载了智能匹配、数据分析、用户管理等关键业务功能。通过模块化的设计方式，各功能组件之间保持松耦合，便于独立迭代与升级。',
      '数据处理层采用多层次的数据存储与处理方案，确保数据的高效存取与安全可靠。喑网91建立了完善的数据备份与容灾机制，最大程度保障用户数据的安全性与可用性。',
    ],
    relatedArticles: [
      { title: '喑网91平台全面介绍', slug: 'platform-overview' },
      { title: '喑网91安全防护体系详解', slug: 'security-system' },
      { title: '喑网91数据分析面板使用指南', slug: 'data-analytics-guide' },
    ],
  },
  'core-features-tutorial': {
    title: '喑网91核心功能使用教程',
    date: '2026-08-12',
    category: '功能指南',
    content: [
      '欢迎使用喑网91核心功能使用教程。本教程将为您详细介绍喑网91平台各项核心功能的使用方法与操作技巧，帮助您快速上手并充分发挥平台的强大能力。',
      '第一步，注册与登录。访问喑网91官网，点击"立即注册"按钮，按照提示完成账号注册。注册成功后，使用您的账号信息登录平台，即可开始探索喑网91的各项功能。',
      '第二步，功能导航。喑网91的主界面采用清晰的导航结构，您可以轻松找到所需的各项功能模块。平台还提供了个性化定制功能，您可以根据自己的使用习惯调整界面布局。',
      '第三步，核心功能使用。喑网91的智能匹配功能可帮助您快速找到所需的服务内容，数据分析面板让您清晰了解使用情况，安全中心保障您的账号与数据安全。',
      '通过本教程的学习，相信您已经对喑网91的核心功能有了全面的了解。如在操作过程中遇到任何问题，欢迎随时联系我们的客服团队获取帮助。',
    ],
    relatedArticles: [
      { title: '喑网91智能匹配功能详解', slug: 'smart-matching' },
      { title: '喑网91数据分析面板使用指南', slug: 'data-analytics-guide' },
      { title: '喑网91账号安全最佳实践', slug: 'account-security' },
    ],
  },
  'smart-matching': {
    title: '喑网91智能匹配功能详解',
    date: '2026-08-08',
    category: '功能指南',
    content: [
      '喑网91智能匹配功能是平台的核心特色之一，通过先进的算法技术，精准识别用户需求并推荐最匹配的服务内容。本文将从功能原理、使用方法和优化技巧三个方面进行详细讲解。',
      '智能匹配功能基于多维度的用户画像分析与内容特征提取技术，能够准确理解用户的偏好与需求，从而提供个性化的服务推荐。系统会持续学习用户的行为模式，不断优化推荐精度。',
      '使用智能匹配功能非常简单，您只需在喑网91平台中正常浏览和使用各项功能，系统会自动记录您的偏好并优化推荐结果。您也可以在设置中手动调整匹配偏好，以获得更加精准的个性化体验。',
      '为了获得最佳匹配效果，建议您完善个人资料与偏好设置，并提供真实的使用反馈。这些信息将帮助智能匹配系统更准确地理解您的需求，推荐更符合您期望的服务内容。',
    ],
    relatedArticles: [
      { title: '喑网91核心功能使用教程', slug: 'core-features-tutorial' },
      { title: '如何在喑网91上提升工作效率', slug: 'efficiency-tips' },
      { title: '喑网91新手上路日记', slug: 'beginner-diary' },
    ],
  },
  'data-analytics-guide': {
    title: '喑网91数据分析面板使用指南',
    date: '2026-08-01',
    category: '功能指南',
    content: [
      '喑网91数据分析面板为用户提供了详尽的数据洞察能力，帮助您全面了解平台使用情况并做出更明智的决策。本指南将为您详细解读各项数据指标的含义与使用方法。',
      '数据分析面板包含多个核心模块：使用概览展示您的基础使用数据，包括访问频次、功能使用分布、活跃时段等信息；趋势分析帮助您了解使用数据的变化趋势；功能热力图为您的功能使用偏好提供直观的可视化呈现。',
      '通过数据分析面板，您可以发现自己的使用习惯与偏好，有针对性地优化使用策略。企业用户还可以利用数据面板了解团队的整体使用情况，为管理决策提供数据支撑。',
      '喑网91数据分析面板将持续升级与完善，引入更多维度的数据指标与更强大的分析功能，为用户提供更全面深入的数据洞察服务。',
    ],
    relatedArticles: [
      { title: '喑网91核心功能使用教程', slug: 'core-features-tutorial' },
      { title: '如何在喑网91上提升工作效率', slug: 'efficiency-tips' },
      { title: '企业用户眼中的喑网91', slug: 'enterprise-perspective' },
    ],
  },
  'latest-version-release': {
    title: '喑网91最新版本发布公告',
    date: '2026-08-11',
    category: '版本更新',
    content: [
      '喑网91最新版本现已正式发布！本次版本更新带来了多项重大功能升级与性能优化，全面提升了用户的使用体验。',
      '主要更新内容包括：全新的界面设计，更加简洁美观；智能匹配算法优化，推荐精度提升30%；数据分析面板新增多项可视化图表；安全性加固，增强了数据加密与风险防护能力。',
      '此外，新版本还修复了若干已知问题，优化了系统性能，缩短了页面加载时间。我们建议所有用户尽快升级到最新版本，以获得最佳的使用体验。',
      '感谢您一直以来对喑网91的支持与信赖。我们将持续努力，为您提供更加优质的服务。如有任何问题或建议，欢迎通过客服渠道与我们联系。',
    ],
    relatedArticles: [
      { title: '喑网91版本更新日志汇总', slug: 'version-changelog' },
      { title: '喑网91新版本升级注意事项', slug: 'upgrade-notes' },
      { title: '喑网91平台架构解析', slug: 'platform-architecture' },
    ],
  },
  'version-changelog': {
    title: '喑网91版本更新日志汇总',
    date: '2026-08-06',
    category: '版本更新',
    content: [
      '本文按时间线汇总了喑网91历次重要版本更新的详细内容，方便用户了解平台的功能演进与持续改进历程。',
      '2026年8月版（最新）：全新界面设计、智能匹配算法优化、数据分析面板升级、安全性加固。',
      '2026年6月版：个性化定制功能上线、移动端体验优化、性能大幅提升。',
      '2026年4月版：数据面板2.0版本发布，新增多项可视化功能。',
      '2026年2月版：安全防护体系升级，引入多层防护机制。',
      '2025年12月版：核心功能全面重构，提升系统稳定性与用户体验。',
    ],
    relatedArticles: [
      { title: '喑网91最新版本发布公告', slug: 'latest-version-release' },
      { title: '喑网91新版本升级注意事项', slug: 'upgrade-notes' },
      { title: '喑网91智能匹配功能详解', slug: 'smart-matching' },
    ],
  },
  'upgrade-notes': {
    title: '喑网91新版本升级注意事项',
    date: '2026-07-30',
    category: '版本更新',
    content: [
      '在升级到喑网91最新版本之前，请您仔细阅读以下注意事项，以确保升级过程顺利进行。',
      '首先，建议您在升级前备份重要数据。虽然喑网91的升级过程经过充分测试，但数据备份始终是保障数据安全的好习惯。',
      '其次，请注意新版本的系统要求。喑网91最新版本可能对操作系统或浏览器版本有最低要求，请确认您的设备满足运行条件。',
      '升级完成后，建议您花一些时间熟悉新版本的界面变化与功能改进。喑网91会在首次启动时提供新功能引导，帮助您快速适应。',
      '如您在升级过程中遇到任何问题，可通过喑网91客服渠道获取技术支持，我们的专业团队将为您提供及时的帮助。',
    ],
    relatedArticles: [
      { title: '喑网91最新版本发布公告', slug: 'latest-version-release' },
      { title: '喑网91版本更新日志汇总', slug: 'version-changelog' },
      { title: '喑网91核心功能使用教程', slug: 'core-features-tutorial' },
    ],
  },
  'security-system': {
    title: '喑网91安全防护体系详解',
    date: '2026-08-09',
    category: '安全保障',
    content: [
      '安全是喑网91平台的重中之重。本文全面介绍喑网91的多层安全防护架构，帮助用户了解平台在数据保护、访问控制与风险监控方面所做的努力。',
      '数据加密方面，喑网91采用业界领先的加密算法，对传输中的数据与存储中的数据均进行加密保护，确保用户数据在任何环节都不会被未授权访问。',
      '访问控制方面，喑网91实施严格的权限管理与身份验证机制。支持双因素认证、设备识别、异常登录检测等多种安全手段，最大程度防止账号被盗用。',
      '风险监控方面，喑网91建立了7x24小时的实时安全监控体系，能够及时发现并响应各类安全威胁。专业的安全团队持续跟踪最新的安全漏洞与攻击手法，确保平台始终处于安全防护的最前沿。',
    ],
    relatedArticles: [
      { title: '喑网91用户隐私保护承诺', slug: 'privacy-protection' },
      { title: '喑网91账号安全最佳实践', slug: 'account-security' },
      { title: '喑网91平台架构解析', slug: 'platform-architecture' },
    ],
  },
  'privacy-protection': {
    title: '喑网91用户隐私保护承诺',
    date: '2026-08-03',
    category: '安全保障',
    content: [
      '喑网91深知用户隐私的重要性，我们郑重承诺严格遵守相关法律法规，以最高的标准保护每一位用户的个人信息与隐私权益。',
      '在数据收集方面，喑网91遵循最小必要原则，仅收集提供核心服务所必需的数据信息。我们会在收集前明确告知用户数据用途，并获得用户的充分授权。',
      '在数据使用方面，喑网91严格限制数据的使用范围，不会将用户数据用于未获授权的用途，也不会向第三方出售或共享用户的个人信息。',
      '在数据保护方面，喑网91投入大量资源建设数据安全防护体系，采用多重技术手段确保用户数据的安全性、完整性与保密性。',
    ],
    relatedArticles: [
      { title: '喑网91安全防护体系详解', slug: 'security-system' },
      { title: '喑网91账号安全最佳实践', slug: 'account-security' },
      { title: '喑网91平台全面介绍', slug: 'platform-overview' },
    ],
  },
  'account-security': {
    title: '喑网91账号安全最佳实践',
    date: '2026-07-25',
    category: '安全保障',
    content: [
      '保护好您的喑网91账号安全，是享受优质服务的基础。本文为您总结了账号安全的最佳实践建议，帮助您远离账号安全风险。',
      '密码管理：建议使用至少12位的强密码，包含大小写字母、数字和特殊字符的组合。避免使用生日、姓名等容易被猜测的信息作为密码，也不要多个平台共用同一密码。',
      '双因素认证：强烈建议开启喑网91的双因素认证功能，为账号增加额外的安全保护层。即使密码不慎泄露，攻击者也无法轻易登录您的账号。',
      '安全习惯：定期检查账号的登录记录与设备列表，发现异常及时处理。不要在公共网络环境下登录喑网91，避免使用共享设备保存登录信息。',
    ],
    relatedArticles: [
      { title: '喑网91安全防护体系详解', slug: 'security-system' },
      { title: '喑网91用户隐私保护承诺', slug: 'privacy-protection' },
      { title: '喑网91核心功能使用教程', slug: 'core-features-tutorial' },
    ],
  },
  'efficiency-tips': {
    title: '如何在喑网91上提升工作效率',
    date: '2026-08-07',
    category: '用户故事',
    content: [
      '作为一名使用喑网91超过三年的资深用户，我想分享一些利用喑网91提升日常工作效率的实用经验。这些技巧已经帮助我和我的团队显著提升了工作产出。',
      '充分利用智能匹配功能：喑网91的智能匹配不仅能推荐服务内容，还能帮助您发现相关资源与工具。花时间完善个人偏好设置，让智能匹配更好地为您服务。',
      '善用数据分析面板：定期查看数据面板中的分析报告，了解自己的使用模式与效率瓶颈。基于数据洞察调整工作策略，往往能带来意想不到的效率提升。',
      '个性化定制界面：根据工作流程定制喑网91的界面布局，将最常用功能置于显眼位置，减少不必要的导航与点击操作。',
    ],
    relatedArticles: [
      { title: '喑网91智能匹配功能详解', slug: 'smart-matching' },
      { title: '喑网91数据分析面板使用指南', slug: 'data-analytics-guide' },
      { title: '企业用户眼中的喑网91', slug: 'enterprise-perspective' },
    ],
  },
  'enterprise-perspective': {
    title: '企业用户眼中的喑网91',
    date: '2026-07-29',
    category: '用户故事',
    content: [
      '越来越多的企业用户选择喑网91作为日常运营的重要工具。本文汇集了多位企业用户的真实评价与使用心得，从企业视角解读喑网91的价值。',
      '某科技公司运营总监张先生表示："喑网91的数据分析功能为我们提供了宝贵的业务洞察。通过数据面板，我们能够实时掌握各项运营指标的变化趋势，及时调整策略。"',
      '某电商团队负责人李女士分享道："喑网91的智能匹配大大提升了我们的工作效率。以前需要花费大量时间手动筛选和查找，现在系统自动推荐最相关的内容，节省了大量时间。"',
      '喑网91已经成为这些企业日常运营不可或缺的工具。随着平台功能的持续完善，相信会有更多企业从喑网91中获益。',
    ],
    relatedArticles: [
      { title: '如何在喑网91上提升工作效率', slug: 'efficiency-tips' },
      { title: '喑网91数据分析面板使用指南', slug: 'data-analytics-guide' },
      { title: '喑网91平台全面介绍', slug: 'platform-overview' },
    ],
  },
  'beginner-diary': {
    title: '喑网91新手上路日记',
    date: '2026-07-22',
    category: '用户故事',
    content: [
      '作为喑网91的新手用户，我记录下了从零开始学习和使用平台的完整经历。希望这篇日记能帮助其他新用户更快地适应和享受喑网91的服务。',
      '第一天：注册了喑网91账号，界面简洁美观，第一印象非常好。花了一些时间浏览了平台的各个功能模块，整体结构清晰，很容易找到需要的功能。',
      '第一周：开始深入了解核心功能。喑网91的使用指南写得非常详细，跟着教程一步步操作，很快就掌握了基本使用方法。智能匹配功能带来了不少惊喜。',
      '一个月后：已经完全融入了喑网91的使用习惯。数据分析面板让我更加了解自己的使用模式，个性化定制功能也让界面越来越符合我的偏好。',
    ],
    relatedArticles: [
      { title: '喑网91核心功能使用教程', slug: 'core-features-tutorial' },
      { title: '喑网91智能匹配功能详解', slug: 'smart-matching' },
      { title: '如何在喑网91上提升工作效率', slug: 'efficiency-tips' },
    ],
  },
};